import React, { Component } from "react";
import { CSVLink } from "react-csv";
import "antd/dist/antd.css";
import {
  Row,
  Col,
  Table,
  Select,
  Menu,
  Dropdown,
  Tag,
  Input,
  Spin,
  Button,
} from "antd";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list } from "../../api/Apis";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import moment from "moment";
import { showTotal, ordersSort } from "../commonFunctions";
import RequestLead from "../../Components/RequestLead";
import LoadDelivered from "../../Components/LoadDelivered";
import GeneratePdf from "../../Components/GeneratePdf";
import ResizableAntdTable from "resizable-antd-table";
import DownloadCsv from "../../Components/DownloadCsv";
const Search = Input.Search;
const { Option } = Select;

class Orders extends Component {
  state = {
    loading: false,
    dataLoading: false,
    defaultStatus: "",
    visible: false,
    totalOrdersList: [],
    orders: [],
    pickDateAndTimeModal: false,
    selectedRecord: {},
    pageLoadingStatus: false,
    userDetails: JSON.parse(localStorage.getItem("userDetails")),
    csvData: [],
  };

  componentDidMount() {
    this.setState({
      dataLoading: true,
    });
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (orgDetails.userProfile !== "SCA") {
      if (orgDetails.approvalStatus === "D") {
        this.props.history.push("/carrier_app/review");
      } else if (
        !orgDetails["carrierFiles"] ||
        !("documents" in orgDetails["carrierFiles"])
      ) {
        this.props.history.push("/carrier_app/documentation");
      } else if (
        this.state.userDetails["userProfile"] === "D" &&
        !this.state.userDetails["isActive"]
      ) {
        this.props.history.push("/carrier_app/review");
      } else if (!orgDetails["isActive"]) {
        this.props.history.push("/carrier_app/review");
      }
    }
    if (!this.state.userDetails["recordStatus"]) {
      this.props.history.push("/carrier_app/review");
    }
    this.getOrders();
  }

  getOrders = async () => {
    let loadList = [];
    if (this.props.match.path === "/carrier_app/myOrders") {
      let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
      getDetails(AppConfigs["myLeadsData"], orgDetails["id"]).then(
        async (result) => {
          if (result.success) {
            loadList = result.data.sort((a, b) =>
              parseInt(a["orderId"]) < parseInt(b["orderId"]) ? 1 : -1
            );
            this.setState({
              orders: loadList,
              totalOrdersList: loadList,
              dataLoading: false,
              csvData: this.prepareCsvData(loadList),
            });
            console.log(this.state.orders)
          } else {
            console.log(result.errors);
            this.setState({
              dataLoadingStatus: false,
            });
          }
        }
      );
    } else {
      let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
      let query = {
        orgId: orgDetails["orgId"],
      };
      list(AppConfigs["carrierLeads"], query).then((result) => {
        if (result.success) {
          let checkLoad = [];
          // let next7thDayDate = moment().add("7", "days");
          // result["data"] = result["data"].filter((l) => {
          //   if (l.deliveryReqDate) {
          //     if (moment(l.deliveryReqDate, "MM/DD/YYYY") < next7thDayDate)
          //       return l;
          //   } else {
          //     return l;
          //   }
          //   return null;
          // });
          if (this.state.userDetails.userProfile === "D") {
            result["data"] = result["data"].filter((l) => {
              if (l?.driverDetails?.id === this.state?.userDetails?.id) {
                return l;
              }
              return null;
            });
          }
          if (orgDetails["tags"]) {
            loadList = [];
            result.data
              .filter((load) => load.orderStatus === "PC")
              .map((load) => {
                if (load["tags"] && load["tags"].length > 0) {
                  load["tags"].map((tag) => {
                    checkLoad = loadList.filter((l) => l.id === load.id);
                    if (
                      orgDetails["tags"].indexOf(tag) > -1 &&
                      checkLoad.length === 0
                    ) {
                      loadList.push(load);
                    }
                    return tag;
                  });
                } else if (load["tags"].length === 0) {
                  loadList.push(load);
                }
                return load;
              });
          } else {
            loadList = result.data;
          }
          loadList = loadList.sort((a, b) =>
            parseInt(a["orderId"]) < parseInt(b["orderId"]) ? 1 : -1
          );
          this.setState({
            orders: loadList,
            totalOrdersList: loadList,
            dataLoading: false,
            csvData: this.prepareCsvData(loadList),
          });
        } else {
          console.log(result.errors);
        }
      });
    }
  };

  searchData = (event, searchType) => {
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalOrdersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchType === "text") {
        this.setState({
          defaultStatus: "",
        });
        totalOrdersList = this.state.totalOrdersList.filter(
          (order) =>
            order.address.toLowerCase().indexOf(searcingValue) > -1 ||
            order.customerName.toLowerCase().indexOf(searcingValue) > -1 ||
            order.orderId.toString() === searcingValue
        );
      } else {
        this.setState({
          defaultStatus: event,
        });
        totalOrdersList = this.state.totalOrdersList.filter(
          (order) => order.orderStatus.toLowerCase() === searcingValue
        );
      }
    } else {
      totalOrdersList = this.state.totalOrdersList;
      this.setState({
        defaultStatus: "",
      });
    }
    this.setState({
      orders: totalOrdersList,
    });
  };

  prepareCsvData = (data) => {
    const csvData = data.map((order) => {
      const orderData = {
        "Order #": order.orderId,
        "Requested Delivery Date": order.deliveryReqDate,
        "Company Name": order.companyName,
        "Load origin": order.productOriginDetails.address,
        "Delivery Location": order.address,
        "Truck Requested": order.deliveryTruck,
        "DeliveryReqDate": order.deliveryReqDate,
        "customerName": order.customerName,
        "productName": order.productName,
        "productSize": order.size,
        "Truck Assigned": order.truckDetails ? order.truckDetails.typeOfTruck : "",
        "Driver Assigned": order.driverDetails ? order.driverDetails.name : "",
        "Load Pickup Date": order.pickupDate,
        "Load Delivery Date": order.deliveryDateAndTime
          ? moment(order.deliveryDateAndTime).format("MM/DD/YYYY hh:mm A")
          : "",
        "Status": AppConfigs["DISPLAY_LEAD_STATUS"]["carrier"][order.orderStatus],
      };
      // console.log('csvData:', csvData)
  
      // Add additional columns dynamically
      // May use later, currently grabbing every key instead of active ones.
      // Object.keys(order).forEach((key) => {
      //   if (!(key in orderData)) {
      //     orderData[key] = order[key];
      //   }
      // });
  
      return orderData;
    });
  
    return csvData;
  };  

  generateCsvData = () => {
    return this.prepareCsvData(this.state.orders);
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.orders !== this.state.orders ||
      prevState.defaultStatus !== this.state.defaultStatus
    ) {
      // Update csvData based on the current state
      this.setState({
        csvData: this.generateCsvData(),
      });
    }
          console.log('csvData:', this.state.orders)

  }


  // createRequestLoad = async (leadData) => {
  //   this.setState({
  //     dataLoading: true,
  //   });
  //   await createRequestLoad(leadData);
  //   // this.getOrders();
  // };

  render() {
    const myOrders = [
      {
        title: "Order #",
        dataIndex: "orderId",
        key: "orderId",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (orderId) => <div>{orderId}</div>,
      },
      {
        title: "Requested Delivery Date",
        dataIndex: "deliveryReqDate",
        key: "deliveryReqDate",
        width: "200px",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (deliverydaterequested, record) => (
          <span>
            <div>{deliverydaterequested}</div>
            <div className="subtext">{record.deliveryReqTime}</div>
          </span>
        ),
      },
      {
        title: "Company Name",
        dataIndex: "customerName",
        key: "customerName",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (customer, record) => (
          <span>
            <div>{record.companyName ? record.companyName : customer}</div>
          </span>
        ),
      },
      {
        title: "Load origin",
        dataIndex: "locationName",
        key: "locationName",
        width: "200px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (locationName, record) => (
          <span>
            <div>
              {record["productOriginDetails"] &&
              Array.isArray(record["productOriginDetails"])
                ? record["productOriginDetails"]?.[0]?.["address"]
                : record["productOriginDetails"]?.["address"]}
            </div>
          </span>
        ),
      },
      {
        title: "Delivery Location",
        dataIndex: "address",
        key: "address",
        width: "210px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (location, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{location}</div>
          </span>
        ),
      },
      {
        title: "Truck Requested",
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        width: "170px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (deliveryTruck, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{deliveryTruck}</div>
          </span>
        ),
      },
      {
        title: "Truck Assigned",
        dataIndex: "typeOfTruck",
        key: "typeOfTruck",
        width: "170px",
        render: (driver, record) => (
          <span>
            <div>
              {record["truckDetails"] && record["truckDetails"]["typeOfTruck"]}
            </div>
            <div className="subtext">
              {record["truckDetails"] && record["truckDetails"]["truckNumber"]}
            </div>
          </span>
        ),
      },
      {
        title: "Driver Assigned",
        dataIndex: "driver",
        key: "driver",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (driver, record) => (
          <span>
            <div>
              {record["driverDetails"] && record["driverDetails"]["name"]}
            </div>
          </span>
        ),
      },
      {
        title: "Load Pickup Date",
        dataIndex: "pickupDate",
        key: "pickupDate",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (loaddate, record) => (
          <span>
            <div>{loaddate}</div>
            <div className="subtext">{record.pickupTime}</div>
          </span>
        ),
      },
      {
        title: "Load Delivery Date",
        dataIndex: "deliveryDateAndTime",
        key: "deliveryDateAndTime",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (deliveryDateAndTime) => (
          <span>
            <div style={{ color: "black" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("MM/DD/YYYY")}
            </div>
            <div className="subtext" style={{ color: "grey" }}>
              {deliveryDateAndTime &&
                moment(deliveryDateAndTime).format("hh:mm A")}
            </div>
          </span>
        ),
      },
      {
        title: "Product Name",
        dataIndex: "productName",
        key: "productName",
        // width: "265px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (productName, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{productName}</div>
          </span>
        ),
      },
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
        // width: "265px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (size, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{size}</div>
          </span>
        ),
      },
      {
        title: "Status",
        key: "orderStatus",
        dataIndex: "orderStatus",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (tag, record) => (
          <div className="customer_orders">
            <Link
              to={"/carrier_app/myOrders/orderdetails/" + record["id"]}
              className="status_tag"
            >
              <Tag
                color={AppConfigs["STATUS_COLORS"][tag]}
                style={{
                  color: "black",
                  height: "27px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {AppConfigs["DISPLAY_LEAD_STATUS"]["carrier"][tag]}
              </Tag>
            </Link>
          </div>
        ),
      },
      {
        title: "Delivery Pic",
        key: "leadDeliveryImage.delivery_pic",
        dataIndex: "leadDeliveryImage.delivery_pic",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/myOrders/orderdetails/" + record.id),
        }),
        render: (imageUrl, record) => (
          <div className="customer_orders">
            <Link
              to={"/carrier_app/myOrders/orderdetails/" + record["id"]}
              className="status_tag"
            >
            </Link>
            {imageUrl && (
              <div>
                {console.log("Delivery Pic URL:", imageUrl)}
                <img src={imageUrl} alt="Delivery Pic" style={{ width: "100px", height: "100px" }} />
              </div>
            )}
          </div>
        ),
      },
      

      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (text, record) => (
          <Dropdown.Button
            overlay={myOrdersMenu(text, record)}
          ></Dropdown.Button>
        ),
      },
    ];

    const myOrdersMenu = (id, record) => (
      <Menu>
        <Menu.Item className="blue">
          <Link as={Link} to={"/carrier_app/myOrders/orderdetails/" + id}>
            Load Details
          </Link>
        </Menu.Item>
        {record.pushToCarrier &&
          !record.assignCarrier &&
          !record.isLoadRequested && (
            <Menu.Item className="blue">
              <span
                onClick={() => {
                  this.setState({
                    pickDateAndTimeModal: true,
                    selectedRecord: record,
                  });
                }}
                style={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.65)" }}
              >
                Request Load
              </span>
            </Menu.Item>
          )}
        {record.orderStatus === AppConfigs["IN_PROGRESS"] && (
          <Menu.Item className="blue">
            <LoadDelivered
              leadData={record}
              callFrom="orders"
              getOrders={() => this.getOrders()}
            />
          </Menu.Item>
        )}
        <Menu.Item className="blue">
          {/* <Link as={Link} to={"/carrier_app/orders/orderdetails/"+id}>Download PDF</Link> */}
          <GeneratePdf
            leadData={record}
            callFrom="carriers"
            pathName="allOrders"
            startLoading={() => this.setState({ pageLoadingStatus: true })}
            stopLoading={() => this.setState({ pageLoadingStatus: false })}
          />
        </Menu.Item>
      </Menu>
    );

    const allOrders = [
      {
        title: "Order #",
        dataIndex: "orderId",
        key: "orderId",
        // sorter: true,
        // width: "150px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (orderId) => <div>{orderId}</div>,
      },
      {
        title: "Ordered On",
        dataIndex: "createdAt",
        key: "createdAt",
        // width: "200px",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (dateordered, record) => (
          <span>
            <div>{moment(dateordered).format("MM/DD/YYYY")}</div>
            <div className="subtext">
              {moment(dateordered).format("hh:mm A")}
            </div>
          </span>
        ),
      },
      {
        title: "Load Origin Location",
        dataIndex: "locationName",
        key: "locationName",
        // width: "250px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (locationName, record) => (
          <span>
            {/* <div>{record["productOriginDetails"] && record["productOriginDetails"]["locationName"]}</div> */}
            <div>
              {record["productOriginDetails"] &&
                record["productOriginDetails"]["address"]}
            </div>
          </span>
        ),
      },
      {
        title: "Load Delivery Location",
        dataIndex: "address",
        key: "address",
        // width: "210px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (location, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{location}</div>
          </span>
        ),
      },
      {
        title: "Requested Truck Type",
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        // width: "265px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (deliveryTruck, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{deliveryTruck}</div>
          </span>
        ),
      },
      {
        title: "Requested Delivery Date",
        dataIndex: "deliveryReqDate",
        key: "deliveryReqDate",
        // width: "200px",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (deliverydaterequested, record) => (
          <span>
            <div>{deliverydaterequested}</div>
            <div className="subtext">{record.deliveryReqTime}</div>
          </span>
        ),
      },
      {
        title: "Customer Name",
        dataIndex: "customerName",
        key: "customerName",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (customer, record) => (
          <span>
            <div>{customer}</div>
            <div className="subtext">{record.companyName}</div>
          </span>
        ),
      },
      {
        title: "Product Name",
        dataIndex: "productName",
        key: "productName",
        // width: "265px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (productName, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{productName}</div>
          </span>
        ),
      },
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
        // width: "265px",
        onCell: (record) => ({
          onClick: () =>
            (window.location =
              "/carrier_app/allOrders/orderdetails/" + record.id),
        }),
        render: (size, record) => (
          <span>
            <div style={{ wordBreak: "break-all" }}>{size}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        // fixed: 'right',
        render: (text, record) => (
          <Dropdown.Button
            overlay={allOrdersMenu(text, record)}
          ></Dropdown.Button>
        ),
      },
    ];

    const allOrdersMenu = (id, record) => (
      <Menu>
        <Menu.Item className="blue">
          <Link as={Link} to={"/carrier_app/allOrders/orderdetails/" + id}>
            Load Details
          </Link>
        </Menu.Item>
        {record.pushToCarrier &&
          !record.assignCarrier &&
          !record.isLoadRequested && (
            <Menu.Item className="blue">
              <span
                onClick={() => {
                  this.setState({
                    pickDateAndTimeModal: true,
                    selectedRecord: record,
                  });
                }}
                style={{ cursor: "pointer", color: "rgba(0, 0, 0, 0.65)" }}
              >
                Request Load
              </span>
            </Menu.Item>
          )}
        {record.orderStatus === AppConfigs["IN_PROGRESS"] && (
          <Menu.Item className="blue">
            <LoadDelivered
              leadData={record}
              callFrom="orders"
              getOrders={() => this.getOrders()}
            />
          </Menu.Item>
        )}
        <Menu.Item className="blue">
          {/* <Link as={Link} to={"/carrier_app/orders/orderdetails/"+id}>Download PDF</Link> */}
          <GeneratePdf
            leadData={record}
            callFrom="carriers"
            pathName="allOrders"
            startLoading={() => this.setState({ pageLoadingStatus: true })}
            stopLoading={() => this.setState({ pageLoadingStatus: false })}
          />
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="orders">
        <Spin spinning={this.state.pageLoadingStatus}>
          <Row>
            <RequestLead
              leadData={this.state.selectedRecord}
              modalStatus={this.state.pickDateAndTimeModal}
              callFrom="orders"
              getOrders={() => this.getOrders()}
              hideModal={() => {
                this.setState({ pickDateAndTimeModal: false });
              }}
            />
            <Col xs={24} sm={24} md={24} lg={24}>
              {this.props.match.path === "/carrier_app/allOrders" && (
                <h1 className="ordertext">All Loads</h1>
              )}
              {this.props.match.path === "/carrier_app/myOrders" && (
                <h1 className="ordertext">My Loads</h1>
              )}
            </Col>
            <Row>
              <Col xs={24} sm={24} md={4} lg={4}>
                <Search
                  className="products-search"
                  size="large"
                  onChange={(event) => {
                    this.searchData(event, "text");
                  }}
                  placeholder="Search"
                />
              </Col>
              {this.props.match.path === "/carrier_app/myOrders" && (
                <>
                  <Col xs={24} sm={24} md={2} lg={2}>
                    <div className="vl" />
                  </Col>
                  <Select
                    className="selectstatus"
                    notFoundContent={"Not found?!"}
                    onChange={(event) => {
                      this.searchData(event, "status");
                    }}
                    defaultValue={"All Status"}
                    value={this.state.defaultStatus}
                  >
                    <Option key="All" value="">
                      All Status
                    </Option>
                    {this.state.userDetails.userProfile !== "D" && (
                      <Option key="AC" value="AC">
                        Assigned to Me
                      </Option>
                    )}
                    <Option key="I" value="I">
                      In Progress
                    </Option>
                    <Option key="D" value="D">
                      Delivered
                    </Option>
                  </Select>
                </>
              )}
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: "2%" }}>
                <div className="orderstable">
                  <ResizableAntdTable
                    style={{ overflowX: "auto" }}
                    bordered={true}
                    columns={
                      this.props.match.path === "/carrier_app/myOrders"
                        ? myOrders
                        : allOrders
                    }
                    dataSource={this.state.orders}
                    loading={this.state.dataLoading}
                    rowKey={(record) => record.id + "-" + record.orderId}
                    onChange={(pagination, filters, sorter) => {
                      this.setState({
                        orders: ordersSort(
                          pagination,
                          filters,
                          sorter,
                          this.state.orders
                        ),
                      });
                    }}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "25", "50", "100"],
                      total: this.state.orders.length,
                      showTotal: showTotal,
                    }}
                    onRow={(r) => ({
                      style: { cursor: "pointer" },
                    })}
                  />
                  <Button>
                    <CSVLink
                      data={this.generateCsvData()}
                      filename={`${this.props.match.path === "/carrier_app/myOrders" ? 'myLoads' : 'allLoads'}_${moment().format('DD_MM_YY')}.csv`}
                      className="csv-download-link"
                      >
                      Download CSV
                    </CSVLink>
                  </Button>
                </div>
              </Col>
            </Row>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withAppContext(withRouter(Orders));
